export default __webpack_public_path__ + "static/media/webinar.c0f438ed.svg";